const SignedIn = 'signedIn';
const SignedOut = 'signedOut';
const Loading = 'loading';
const NewPasswordRequired = 'newPasswordRequired';
const All = [SignedOut, SignedIn, Loading];

export { SignedIn, SignedOut, Loading, All, NewPasswordRequired };
